import { upsertSchedule, upsertSchedules } from '@dispatch/shared/services';
import { Schedule } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useUpsertSchedule = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-resource-schedules'],
    (data: Schedule) => upsertSchedule(data),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    upsertSchedule: mutate,
    upsertScheduleError: error,
    upsertScheduleStatus: status,
  };
};

export const useUpsertSchedules = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-resource-schedules'],
    (data: Schedule[]) => upsertSchedules(data),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    upsertSchedules: mutate,
    upsertSchedulesError: error,
    upsertSchedulesStatus: status,
  };
};
